import { render, staticRenderFns } from "./DeleteShiftTypeDialog.vue?vue&type=template&id=667e74b2&"
import script from "./DeleteShiftTypeDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteShiftTypeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports